import { render, staticRenderFns } from "./OtpForm.vue?vue&type=template&id=a0669f62&scoped=true"
import script from "./OtpForm.vue?vue&type=script&lang=js"
export * from "./OtpForm.vue?vue&type=script&lang=js"
import style0 from "./OtpForm.vue?vue&type=style&index=0&id=a0669f62&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0669f62",
  null
  
)

export default component.exports